import React from 'react'
import style from './authView.module.scss'
import Register from './Register/Register'
import Login from './Login/Login'

type TAuthView = {
  type: 'signIn' | 'signUp'
}
export function AuthView({ type }: TAuthView) {
  return (
    <div className={style.wrapper}>
      {type === 'signIn' && <Login />}
      {type === 'signUp' && <Register />}
    </div>
  )
}
